import DatabaseReference from '../platform/DatabaseReference';
import DriverModel from '../../models/scoopm/Driver';

export default class Driver extends DatabaseReference {
  get Model() {
    return DriverModel;
  }
}
